import styled from 'styled-components';

export const ErrorMessage = styled.p`
  margin-top: 1rem;
  color: var(--red);
  font-size: clamp(1.6rem, 3vw, 1.8rem);
`;
